export default function Row({ children, className = "mb-1 p-1", style = {} }) {
  return (
    <div className={`row ${className}`} style={style}>
      {children}
    </div>
  );
}
